
import React from 'react';
import { motion } from 'framer-motion';
import TouchSlider from '../../../components/base/TouchSlider';

const stats = [
  { icon: 'ri-time-line', label: 'Czas odpowiedzi', value: '< 24h' },
  { icon: 'ri-calendar-check-line', label: 'Doświadczenie', value: '35+ lat' },
  { icon: 'ri-team-line', label: 'Zespół ekspertów', value: '19 osób' },
  { icon: 'ri-shield-check-line', label: 'Certyfikaty', value: 'ISO 9001' },
];

export default function ContactHero() {
  return (
    <section className="relative pt-28 sm:pt-32 pb-16 sm:pb-24 bg-[#050505] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5bebdb7c0bd987ad6c88d0f78866c43b.jpg"
          alt="Kontakt EUREKA"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-[#050505]/80 to-[#050505]"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          className="text-center"
        >
          <span
            className="text-[#00E5FF] text-[10px] sm:text-sm tracking-[0.2em] sm:tracking-[0.3em] uppercase font-semibold"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            Skontaktuj się z nami
          </span>
          <h1
            className="text-3xl sm:text-5xl md:text-6xl font-bold text-white mt-3 sm:mt-4 leading-tight"
            style={{ fontFamily: 'Rajdhani, sans-serif' }}
          >
            Rozpocznij <span className="text-[#00E5FF]">Współpracę</span>
          </h1>
          <p
            className="text-sm sm:text-lg text-[#C0C7CF] mt-4 sm:mt-6 max-w-3xl mx-auto leading-relaxed px-2"
            style={{ fontFamily: 'Inter, sans-serif' }}
          >
            Nasz zespół ekspertów jest gotowy odpowiedzieć na Twoje pytania i pomóc w
            realizacji nawet najbardziej wymagających projektów przemysłowych.
          </p>
        </motion.div>

        {/* Desktop grid */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="hidden sm:grid grid-cols-2 md:grid-cols-4 gap-4 lg:gap-6 mt-12 md:mt-16"
        >
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-[#111111]/80 backdrop-blur-sm border border-[#00E5FF]/10 p-5 lg:p-6 text-center hover:border-[#00E5FF]/40 transition-all duration-500"
            >
              <div className="w-10 h-10 lg:w-12 lg:h-12 flex items-center justify-center mx-auto mb-3">
                <i className={`${stat.icon} text-xl lg:text-2xl text-[#00E5FF]`}></i>
              </div>
              <div
                className="text-xl lg:text-2xl font-bold text-white mb-1"
                style={{ fontFamily: 'Rajdhani, sans-serif' }}
              >
                {stat.value}
              </div>
              <div
                className="text-[#C0C7CF] text-[10px] lg:text-xs tracking-wider uppercase"
                style={{ fontFamily: 'Inter, sans-serif' }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </motion.div>

        {/* Mobile slider */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1, delay: 0.3 }}
          className="sm:hidden mt-8"
        >
          <TouchSlider gap={12} showDots itemArrows={false} itemClassName="w-[70vw]">
            {stats.map((stat, index) => (
              <div
                key={index}
                className="bg-[#111111]/80 backdrop-blur-sm border border-[#00E5FF]/10 p-5 text-center w-full"
              >
                <div className="w-10 h-10 flex items-center justify-center mx-auto mb-3">
                  <i className={`${stat.icon} text-xl text-[#00E5FF]`}></i>
                </div>
                <div
                  className="text-xl font-bold text-white mb-1"
                  style={{ fontFamily: 'Rajdhani, sans-serif' }}
                >
                  {stat.value}
                </div>
                <div
                  className="text-[#C0C7CF] text-[10px] tracking-wider uppercase"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                >
                  {stat.label}
                </div>
              </div>
            ))}
          </TouchSlider>
        </motion.div>
      </div>
    </section>
  );
}
